export const ERRORS = {
    GENERAL_ERROR: 'general_error',
};
